var hashtag_default = {
  "fontElementMap": "wfg3k",
  "hashtag": "_73t1A"
};
export {
  hashtag_default as default
};
//# sourceMappingURL=hashtag-scss.js.map
